import request from "../../shared/lib/request";
import constants from "../../shared/constants";
import { UserDataType } from "../../shared/types";

const get = (id: string) => {
  const authToken = localStorage.getItem(
    constants.LOCAL_STORAGE.KEYS.AUTH_TOKEN
  );

  let headers: any = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${authToken}`,
  };

  const url = `/api/v1/user/${id}`;

  return request({
    url,
    method: "GET",
    headers,
  });
};

const update = (id: string, data: UserDataType) => {
  const authToken = localStorage.getItem(
    constants.LOCAL_STORAGE.KEYS.AUTH_TOKEN
  );

  let headers: any = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${authToken}`,
  };

  const url = `/api/v1/user/${id}`;

  return request({
    url,
    method: "PATCH",
    headers,
    data,
  });
};

const getPets = (id: string) => {
  const authToken = localStorage.getItem(
    constants.LOCAL_STORAGE.KEYS.AUTH_TOKEN
  );

  let headers: any = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${authToken}`,
  };

  const url = `/api/v1/user/${id}/pet`;

  return request({
    url,
    method: "GET",
    headers,
  });
};

const UsersService = {
  get,
  update,
  getPets,
};

export default UsersService;
